const CHECKOUT_POPUP_WIDTH = 900;
const CHECKOUT_POPUP_HEIGHT = 800;

export const openCheckoutPopup = (checkoutUrl: string): Window | null => {
  const width = CHECKOUT_POPUP_WIDTH;
  const height = CHECKOUT_POPUP_HEIGHT;
  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;
  const features = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`;

  return window.open(checkoutUrl, 'shopifyCheckout', features);
};
